import InputTextarea from "../../../../components/input/input-textarea.jsx";

export default function EncounterJustification({ data, onChange }){
    return (
        <InputTextarea
            id="observation"
            textAreaClass={"h-[10rem]"}
            value={data ?? ""}
            onChange={(e) => onChange?.(e.target.value)}
        />
    )
}